var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetappLogo = function SvgGetappLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "1em",
    height: "1em",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 5.88284L6.75781 5.88417L10.867 5.88486V1.88756L0 5.88284Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8676 1.88752V16L15.9999 0L10.8676 1.88752Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8669 5.88496L6.75766 5.88428L10.8669 16.0001V5.88496Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 5.88281L7.81157 8.47973L6.75781 5.88414L0 5.88281Z",
    fill: "currentColor"
  }))));
};
export default SvgGetappLogo;